var _path, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagnifyingGlass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 6.49997C12.25 9.44283 9.71545 11.8986 6.5 11.8986C3.28455 11.8986 0.75 9.44283 0.75 6.49997C0.75 3.5571 3.28455 1.10132 6.5 1.10132C9.71545 1.10132 12.25 3.5571 12.25 6.49997Z",
    stroke: "#888888",
    strokeWidth: 1.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: -0.75,
    x2: 4.12957,
    y2: -0.75,
    transform: "matrix(-0.726468 -0.6872 0.726468 -0.6872 14 12.6487)",
    stroke: "#888888",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifyingGlass);
export default __webpack_public_path__ + "static/media/magnifyingGlass.a6077dda17a0a8120b1c162dc7ac8da5.svg";
export { ForwardRef as ReactComponent };